export default __webpack_public_path__ + "static/media/Ficha_maiz.13ce6f3e.png";